import React, { useEffect, useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { categories, techStacks } from '../../../../data/LandingSectionData/techStackData';
import { Timeline } from "../../../../Components/Timeline";
import TechCard from "../../../../Components/TechCard";


export function TimelineDemo() {


    const [activeCategory, setActiveCategory] = useState('Frontend');

    useEffect(() => {
        AOS.init({ once: false });
    }, []);

    useEffect(() => {
        AOS.refresh();
    }, [activeCategory]);

    const data = [
        {
            title: "The Challenge",
            content: (
                <div>
                   <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              A leading psychiatric clinic approached us to digitize their consultation and therapy workflow. Their goal was to 
                              streamline patient management, track session notes, manage prescriptions, and enhance 
                              teleconsultation efficiency with a secure, clinical-grade app.
                            </p>
                    <div className="grid md:grid-cols-2 gap-4">
                        <img src='/case_studies/mental_health_img/challenge_img.png' className='w-full h-full'></img>
                    </div>
                </div>
            ),
        },
        {
            title: "Our Solution",
            content: (
                <div>
                   <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              A leading psychiatric clinic approached us to digitize their consultation and therapy workflow. Their goal was to 
                              streamline patient management, track session notes, manage prescriptions, and enhance 
                              teleconsultation efficiency with a secure, clinical-grade app.
                            </p>
                    <div className="grid grid-cols-2 gap-4">
                        <img src='/case_studies/mental_health_img/our_solutions_img.png'></img>
                    </div>
                </div>
            ),
        },
        {
            title: "Tech Stack",
            content: (
                <div>
                    <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              A leading psychiatric clinic approached us to digitize their consultation and therapy workflow. Their goal was to 
                              streamline patient management, track session notes, manage prescriptions, and enhance 
                              teleconsultation efficiency with a secure, clinical-grade app.
                            </p>
                    <div
                        className="grid grid-cols-4 sm:grid-cols-3 md:grid-cols-4
                                      justify-items-center gap-x-4 gap-y-6
                                      max-h-[400px] overflow-y-auto sm:overflow-visible"
                        data-aos="fade-up"
                        data-aos-easing="linear"
                        data-aos-duration="1000"
                        key={activeCategory}
                    >
                        {(techStacks[activeCategory] || []).map((tech, index) => (
                            <TechCard key={index} icon={tech.icon} name={tech.name} />
                        ))}
                    </div>
                </div>
            ),
        },
    ];
    return (
        <div className="relative w-full overflow-clip bg-[#1F1F1F]">
            <Timeline data={data} />
        </div>
    );
}
